import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPosterState } from "../store/poster/selectors";
import { getPostersByTenantId } from "../store/poster/thunks";

export const usePoster = () => {
  const dispatch = useDispatch();

  const { posters, loading, allFetched } = useSelector(selectPosterState);

  const fetchPosters = useCallback(() => {
    if (!allFetched) {
      dispatch(
        getPostersByTenantId({
          offset: posters?.length || 0,
        }),
      );
    }
  }, [posters?.length, allFetched]);

  useEffect(() => {
    if (posters && !allFetched) {
      fetchPosters();
    }
  }, []);

  return {
    posters,
    loading,
    fetchPosters,
    allFetched,
  };
};
